// SEO data for all pages
export const seoData = {
  home: {
    ko: {
      title: 'AI 기반 교육 플랫폼',
      description: 'AI로 학습 잠재력을 극대화하세요. 회로 훈련 프로그램, 문제 은행 관리자, 분석 대시보드로 한국 교육을 혁신합니다.',
      keywords: 'AI 교육, 한국 교육 플랫폼, 회로 훈련, 문제 은행, 학습 분석, 학생 관리, AI 학습, 교육 기술',
    },
    en: {
      title: 'AI-Powered Educational Platform',
      description: 'Maximize learning potential with AI. Transform Korean education with Circuit Training, Problem Bank Manager, and Analytics Dashboard.',
      keywords: 'AI education, Korean education platform, circuit training, problem bank, learning analytics, student management, AI learning, edtech',
    },
  },
  
  about: {
    ko: {
      title: '회사 소개',
      description: 'KAIST와 UC Berkeley 출신 팀이 만든 AI 교육 플랫폼. 혁신적인 AI 기술로 교육을 변화시키고, 누구나 수준 높은 학습을 경험할 수 있도록 돕습니다.',
      keywords: 'Aidu 소개, KAIST, UC Berkeley, AI 교육 회사, 교육 기술 스타트업, 한국 에듀테크',
    },
    en: {
      title: 'About Us - KAIST & UC Berkeley Team',
      description: 'Founded by KAIST and UC Berkeley alumni, Aidu transforms education through innovative AI technology, making quality learning accessible to everyone.',
      keywords: 'About Aidu, KAIST, UC Berkeley, AI education company, edtech startup, Korean edtech',
    },
  },
  
  products: {
    ko: {
      title: '제품 및 가격',
      description: 'AI 기반 교육 솔루션: 회로 훈련 프로그램, 문제 은행 관리자, 분석 대시보드, 학생 관리 시스템. 교육 콘텐츠를 생성, 관리, 제공하는 포괄적인 솔루션입니다.',
      keywords: '교육 제품, AI 학습 도구, 회로 훈련, 문제 은행, 학생 분석, 교육 관리 시스템',
    },
    en: {
      title: 'Products & Pricing',
      description: 'AI-powered educational solutions: Circuit Training Program, Problem Bank Manager, Analytics Dashboard, Student Management. Comprehensive tools for creating, managing, and delivering educational content.',
      keywords: 'education products, AI learning tools, circuit training, problem bank, student analytics, education management system',
    },
  },
  
  contact: {
    ko: {
      title: '문의하기',
      description: '에이듀에 문의하세요. AI 기반 교육 솔루션에 대해 궁금한 점이 있으시면 언제든지 연락주세요. 빠르게 답변드리겠습니다.',
      keywords: '에이듀 문의, AI 교육 상담, 제품 데모, 영업 문의, 고객 지원',
    },
    en: {
      title: 'Contact Us',
      description: 'Get in touch with Aidu. Have questions about our AI-powered educational solutions? Contact us and we\'ll respond promptly.',
      keywords: 'contact Aidu, AI education inquiry, product demo, sales inquiry, customer support',
    },
  },
  
  circuitTraining: {
    ko: {
      title: '회로 훈련 프로그램 - AI 기반 문제 해결 학습',
      description: 'AI 기반 회로 훈련으로 학생들의 문제 해결 능력을 향상시키세요. 개인 맞춤형 학습 경로, AI 솔루션 분석, 손글씨 인식으로 정확한 피드백을 제공합니다.',
      keywords: '회로 훈련, AI 문제 해결, 맞춤형 학습, AI 피드백, 손글씨 분석, 수학 학습, 문제 세트',
    },
    en: {
      title: 'Circuit Training Program - AI-Powered Problem Solving',
      description: 'Improve students\' problem-solving skills with AI-powered circuit training. Personalized learning paths, AI solution analysis, and handwriting recognition for accurate feedback.',
      keywords: 'circuit training, AI problem solving, personalized learning, AI feedback, handwriting analysis, math learning, problem sets',
    },
  },
  
  problemBank: {
    ko: {
      title: '문제 은행 관리자 - 교육 콘텐츠 관리 시스템',
      description: '강력한 검색, 태그 지정, 분류 도구로 문제 은행을 효율적으로 관리하세요. 문제 세트 생성, PDF 업로드, 무제한 저장 기능을 제공합니다.',
      keywords: '문제 은행, 교육 콘텐츠 관리, 문제 세트 생성, 교육 자료 관리, 시험 문제 관리',
    },
    en: {
      title: 'Problem Bank Manager - Educational Content Management',
      description: 'Efficiently manage your problem bank with powerful search, tagging, and categorization tools. Create problem sets, upload PDFs, and unlimited storage.',
      keywords: 'problem bank, educational content management, problem set creation, teaching materials management, exam question management',
    },
  },
  
  analyticsDashboard: {
    ko: {
      title: '분석 대시보드 - 학생 성과 추적 및 분석',
      description: '포괄적인 학생 성과 분석 도구로 학습 진행 상황을 추적하세요. 개인별 분석, 문제 유형별 통찰력, 학습 이력 관리를 제공합니다.',
      keywords: '학습 분석, 학생 성과 추적, 교육 데이터 분석, 학습 통찰력, 성적 관리, 진도 추적',
    },
    en: {
      title: 'Analytics Dashboard - Student Performance Tracking',
      description: 'Track student progress with comprehensive performance analytics tools. Individual analysis, problem-type insights, and learning history management.',
      keywords: 'learning analytics, student performance tracking, education data analysis, learning insights, grade management, progress tracking',
    },
  },
  
  studentManagement: {
    ko: {
      title: '학생 관리 시스템 - 효율적인 학급 및 학생 관리',
      description: '학급과 학생을 효율적으로 관리하세요. 학생 목록 업로드, 과제 할당, 개인/학급 성과 분석, 학부모 리포트 발송 기능을 제공합니다.',
      keywords: '학생 관리, 학급 관리, 과제 관리, 학부모 소통, 성적 리포트, 교육 행정',
    },
    en: {
      title: 'Student Management System - Efficient Class & Student Management',
      description: 'Manage classes and students efficiently. Upload student lists, assign tasks, analyze individual/class performance, and send parent reports.',
      keywords: 'student management, class management, assignment management, parent communication, grade reports, education administration',
    },
  },
};

